<div [ngClass]="class">
  <lib-container>
    <h3 class="text-center mb-3">
      {{ isNewCustomerPlan ? textData.newSubscriptionPlans.PlanSubscriptionTitle : textData.subscriptionPlans.PlanSubscriptionTitle }}
    </h3>

    <p class="{{ class + '__subtitle text-center text-dark-grey' }}">
      {{ isNewCustomerPlan ? textData.newSubscriptionPlans.PlanSubscriptionSubTitle : textData.subscriptionPlans.PlanSubscriptionSubTitle }}
    </p>
  </lib-container>

  <div
    [ngClass]="{
      'scrollable overflow-x-scroll overflow-y-hidden': plans.length >= 2
    }"
    (mousedown)="startDrag($event)"
    (mousemove)="onDrag($event)"
    (mouseup)="stopDrag()"
    (mouseleave)="stopDrag()"
    #scrollContainer
  >
    <div
      class="{{ class + '__items' }} justify-center overflow-visible mx-auto"
      [ngClass]="{
        grid: plans.length <= 2,
        flex: plans.length >= 3
      }"
    >
      <ng-container *ngFor="let plan of plans; let i = index">
        <div class="col-12 w-full xl:col-6 xl:w-6 flex-column">
          <ng-container *ngIf="isNewCustomerPlan; else upgradePlan">
            <lib-new-plan-selector [activePlan]="(plan$ | async)!" [isSubscriptionPlans]="true" [plan]="plan"></lib-new-plan-selector>
          </ng-container>
          <ng-template #upgradePlan>
            <lib-plan-selector [activePlan]="(plan$ | async)!" [isSubscriptionPlans]="true" [plan]="plan"></lib-plan-selector>
          </ng-template>
        </div>
      </ng-container>
    </div>
  </div>

  <div>
    <p class="text-center text-dark-grey mt-5">
      Weitere Informationen zum Inhalt des Pakets und der Module finden Sie unter:
      <a href="https://smarthandwerk.de/leistungsbeschreibungen/" class="text-underlined" target="_blank">
        https://smarthandwerk.de/leistungsbeschreibungen/
      </a>
    </p>
  </div>
</div>
